import { render } from "./teamData.vue?vue&type=template&id=191dbf9e&scoped=true"
const script = {}

import "./teamData.vue?vue&type=style&index=0&id=191dbf9e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191dbf9e"]])

export default __exports__